import { emptySplitApi } from "../../injectEndpoints";

export const Reservation = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getReservation: builder.query({
      query: (data) => {
        return {
          url: `/dashboard/getReservations`,
          method: "GET",
          params: data,
        };
      },
      // Replace with your actual endpoint
      providesTags: ["getDashboardFluctuationOverview"],
    }),
  }),
  overrideExisting: false,
});

export const {
useGetReservationQuery
} = Reservation;
